import {memo, ReactNode} from 'react';

import styled from 'styled-components';

import PieButton from '~/shared/theme/pie/PieButton';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {writeToClipboard} from '~/shared/utils/clipboard';
import {SnackbarProvider, SnackbarView, useSnackbar} from '~/personalArea/components/Sections/Settings/Snackbar';
import {getLocalizationService} from '~/shared/services/localisationService';

import CopyToClipboardIcon from './copyToClipboardIcon.svg?react';

const ClipboardButton = styled(PieButton).attrs({
  variant: 'secondaryLarge',
})`
  direction: ltr;
  border-radius: 6px;
`;

const StyledCopyToClipboardIcon = styled(CopyToClipboardIcon).attrs({
  width: 22,
  height: 22,
  viewBox: '0 0 32 32',
})`
  ${flipOnLTR`
    margin-right: 3px;
  `}
`;

type CopyToClipboardButtonProps = {
  children: ReactNode;
  textToCopy: string;
  onCopy?: () => void;
};

const CopyToClipboardButton = ({children, textToCopy, onCopy}: CopyToClipboardButtonProps) => {
  const {t} = getLocalizationService();
  const {showSnackbar} = useSnackbar();

  const writeToClipboardHandler = () => {
    writeToClipboard(textToCopy);
    showSnackbar();
    if (onCopy) {
      onCopy();
    }
  };

  return (
    <>
      <ClipboardButton onClick={writeToClipboardHandler}>
        <StyledCopyToClipboardIcon />
        {children}
      </ClipboardButton>
      <SnackbarView>{t('copied_to_clipboard')}</SnackbarView>
    </>
  );
};

const CopyToClipboardButtonWrapper = (props: CopyToClipboardButtonProps) => (
  <SnackbarProvider>
    <CopyToClipboardButton {...props} />
  </SnackbarProvider>
);

export default memo(CopyToClipboardButtonWrapper);
